export const ENVIROMENT = {
  API: process.env.REACT_APP_API,
  UPLOAD_FILE_IMAGE: process.env.REACT_APP_UPLOAD_FILE_IMAGE
};
